module.exports = __webpack_public_path__ + "img/codeimg1.08034398.jpg";